<ng-container *ngIf="visible">
  <div class="navbar-item" [ngClass]="{ 'is-active': type === 'active' }">
    <a
      class="is-flex is-align-items-center is-justify-content-center is-flex-direction-column"
      [routerLink]="['/licenses/active']"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="19px"
        viewBox="0 -960 960 960"
        width="19px"
        fill="currentColor"
      >
        <path
          d="m424-318 282-282-56-56-226 226-114-114-56 56 170 170ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22q38 0 68.5 22t43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm280-670q13 0 21.5-8.5T510-820q0-13-8.5-21.5T480-850q-13 0-21.5 8.5T450-820q0 13 8.5 21.5T480-790Z"
        />
      </svg>
      <span class="navbar-item-label" translationEditableDirective="ACTIVE">{{
        'ACTIVE' | translate
      }}</span>
    </a>
  </div>
  <div
    class="navbar-item"
    [ngClass]="{ 'is-active': type === 'archived' }"
    *ngxPermissionsOnly="['BUSINESS_ACTION_ARCHIVE']"
  >
    <a
      class="is-flex is-align-items-center is-justify-content-center is-flex-direction-column"
      [routerLink]="['/licenses/archived']"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="19px"
        viewBox="0 0 24 24"
        width="19px"
        fill="currentColor"
      >
        <path
          d="M3,3H21V7H3V3M4,8H20V21H4V8M9.5,11A0.5,0.5 0 0,0 9,11.5V13H15V11.5A0.5,0.5 0 0,0 14.5,11H9.5Z"
        />
      </svg>

      <span class="navbar-item-label" translationEditableDirective="ARCHIVED">{{
        'ARCHIVED' | translate
      }}</span>
    </a>
  </div>
</ng-container>
